const MOBILE_BREAK_POINT = 800
const TABLET_BREAK_POINT = 1070

export default {
  mounted () {
    window.addEventListener('resize', this.initWidth)
  },

  destroyed () {
    window.removeEventListener('resize', this.initWidth)
  },

  data: () => ({
    windowWidth: window.innerWidth
  }),

  methods: {
    initWidth () {
      this.windowWidth = window.innerWidth
    }
  },

  computed: {
    isMobile () {
      return this.windowWidth <= MOBILE_BREAK_POINT
    },

    isTablet () {
      return this.windowWidth <= TABLET_BREAK_POINT &&
        this.windowWidth > MOBILE_BREAK_POINT
    },

    isDesktop () {
      return this.windowWidth > TABLET_BREAK_POINT
    }
  }
}
